@if (data(); as msg) {
   Department {{msg.code}} <span>already exists.</span>
}
 